<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import filters from "./filters/_filters";

  import userService from './services/user.service'
  import clientService from './services/client.service'
  import currencyService from './services/currency.service'
  import timezoneService from './services/timezone.service'

  import state from './state'

  export default {
    name: 'app',
    async mounted() {
      var adm = await userService.get();
      if (adm) {
        state.admin.set(adm);
        await clientService.loadClient();
      }
      await currencyService.loadAll();
      await timezoneService.loadAll();
    }
  }
</script>

<style lang="scss" src="./main.scss"></style>



// WEBPACK FOOTER //
// src/App.vue